// Must match the backend limit (MAX_CLASSROOMS_PER_USER); the backend enforces it.
export const MAX_CLASSROOMS = 10;
export const GROUP_LIMIT_HINT = `Достигнут лимит — ${MAX_CLASSROOMS} активных групп`;
// Must match the backend limit (MAX_CLASSROOM_MEMBERS); the backend enforces it.
export const MAX_GROUP_MEMBERS = 100;

// A lesson link (/lesson/<code>) or an invite link (/join/<code>).
const NEXT_PATH = /^\/(lesson|join)\/[A-Za-z0-9]{1,32}$/;
const POST_LOGIN_REDIRECT_KEY = 'postLoginRedirect';

export const lessonPath = (code: string) => `/lesson/${code}`;

export const lessonUrl = (code: string) => `${window.location.origin}${lessonPath(code)}`;

export const joinPath = (code: string) => `/join/${code}`;

export const joinUrl = (code: string) => `${window.location.origin}${joinPath(code)}`;

export const groupPath = (classroomId: string) => `/classrooms/${classroomId}`;

/**
 * Only a lesson or invite link path is accepted as a post-login target, so
 * `?next=` can't be used as an open redirect.
 */
export function safeNextPath(value: string | null | undefined): string | null {
  return value && NEXT_PATH.test(value) ? value : null;
}

/** `?next=` for the login / registration pages. */
export const withNext = (page: '/login' | '/register', next: string | null) =>
  next ? `${page}?next=${encodeURIComponent(next)}` : page;

/**
 * OAuth providers always return to the site root, so the target is kept in
 * sessionStorage (same tab) across the provider round trip. Passing null
 * drops a stale target from an abandoned attempt.
 */
export function savePostLoginRedirect(path: string | null): void {
  try {
    if (path) {
      sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
    } else {
      sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    }
  } catch {
    // storage unavailable (private mode): fall back to landing on /
  }
}

export function consumePostLoginRedirect(): string | null {
  try {
    const path = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    return safeNextPath(path);
  } catch {
    return null;
  }
}
